<template>
  <Dialog
    v-model:visible="visible"
    style="width: 80vw"
    :modal="true"
    :closable="false"
  >
    <template #header>
      <h1 v-if="version?.name">
        Versão {{ version.name }}
        <span v-if="version.title"> - {{ version.title }}</span>
        <span v-if="version.date"> - {{ $formatDate(version.date) }}</span>
      </h1>
    </template>
    <div
      class="description"
      v-if="version?.description"
      v-html="marked(version.description)"
    ></div>
    <template #footer>
      <div class="p-grid p-jc-end p-mt-2">
        <div class="p-col-fixed">
          <AppButton label="Fechar" @click="close()" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'VersionNotesDialog',
  props: {
    version: Object,
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    version(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.visible = true;
      }
    },
  },
  methods: {
    marked,
    close() {
      this.visible = false;
      this.$emit('update:version', null);
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.8rem;
}
h2 {
  font-size: 1.5rem;
}

.description >>> h2 {
  font-size: 1.3rem;
}

.description >>> img {
  max-width: 100%;
}
</style>